let info = {
  name: "Patrick Bradshaw",
  logo_name: "Bradshaw",
  flat_picture: require("./src/assets/Patrick_Bradshaw_Headshot.jpg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: true
    }
  },
  title: "AWS Architect & Professional Problem Solver",
  description:
    "Hello, I'm Patrick Bradshaw, a solutions architect and software engineer based out of Dallas, Texas. Delivering custom solutions for customers as a consultant for more than 5 years, I bring a wide range of experience and customer obsession to build effective cloud solutions that meet the unique needs, constraints, and goals of customers in any domain.",
  links: {
    linkedin: "https://www.linkedin.com/in/patricksbradshaw",
    github: "",
    behance: "",
    resume: "",
  },
  education: [
    {
      name: "University of Southern California",
      place: "Los Angeles",
      // date: "sep, 2018 - present",
      degree: "M.S., Computer Science",
      // gpa: "3.1/4.0",
      description:
        "",
      skills: [
        "Software Engineering",
        "Software Architecture",
      ]
    },
    {
      name: "University of Southern California",
      place: "Los Angeles",
      // date: "sep, 2018 - present",
      degree: "B.S., Computer Science/Business Administration",
      // gpa: "3.1/4.0",
      description:
        "",
      skills: [
        "Software Engineering",
        "Business Organizations",
        "Video Game Programming"
      ]
    },
  ],
  experience: [
    {
      name: "Pariveda Solutions",
      place: "Dallas, Texas",
      date: "July 2017 - Present",
      position: "Solutions Architect / Project Manager",
      description:
        "Specializing in cloud solutions architectures, I have served customers across a variety of industries including financial services, healthcare, and commercial retail",
      skills: ["AWS", "IaC (CF, TF)", "Agile/Scrum", "SAFe", "Project Management", "Azure", "JavaScript", "TypeScript", ".NET/.NET Core", "DevOps (ADO, GH Actions, BB Pipelines)"]
    },
    {
      name: "VISA, Inc",
      place: "Austin, Texas",
      date: "May 2016 - August 2016",
      position: "Software Engineer Intern",
      description:
        "In anticipation of the Rio Summer Olympics, I delivered scalable carousel elements and localization for Visa Checkout on iOS",
      skills: ["Swift", "Agile/Scrum", "iOS"]
    },
    {
      name: "Envoy Now",
      place: "Los Angeles, CA",
      date: "September 2014 - May 2015",
      position: "Contract Developer",
      description: "The sole developer for Envoy Now in it's early stages, I designed and implemented the iOS UI and backend layers to power student-to-student restaurant delivery. To scale the service, this solution incorporated SMS & GPC order tracking as well as Stripe and ACH integration for accepting payments and facilitating contractor payment schedules",
      skills: ["Objective-C", "iOS", "Parse", "Stripe", "Project Management"]
    },
  ],
  skills: [
    {
      title: "Cloud Services",
      info: ["AWS (Certified Professional Solutions Architect)", "Azure"],
      icon: "fa fa-cloud"
    },
    {
      title: "Architectural Paradigms",
      info: [
        "CQRS", "Docker/Containers", "Component based architecture", "SPA", "Salesforce Commerce Cloud (SFCC, SFRA)", "Inner Source"],
      icon: "fa fa-sitemap"
    },
    {
      title: "Project Management Paradigms",
      info: [
        "Agile", "Scrum", "SAFe"],
      icon: "fa fa-users"
    },
    {
      title: "Language Proficiencies",
      info: ["JavaScript", "TypeScript", "C#", "C/C++", "Swift", "Objective-C", "Java", "Python"],
      icon: "fas fa-laptop-code"
    },
  ],
  portfolio_professional: [
    {
      name: "Tax Preparation Modernization",
      title: "Tax Preparation Modernization",
      pictures: [
        {
          img: require("./src/assets/portfolio/professional/tax-platform/tax-image.jpeg"),
          title: ""
        },
      ],
      technologies: ["AWS", "ECS", ".NET Core", "Azure DevOps"],
      category: "AWS & Solution Architecture",
      github: "",
      date: "Jan 2020",
      visit: "",
      description:
        "A brief description"
    },
  ],
  portfolio_personal: [
    {
      name: "Fraiche",
      pictures: [
        {
          img: require("./src/assets/portfolio/personal/fraiche/title.png")
        },
        {
          img: require("./src/assets/portfolio/personal/fraiche/solution.png")
        },
      ],
      technologies: ["Swift", "iOS", "AWS", "python", "Parse"],
      category: "iOS App",
      date: "March 2017",
      github:
        "",
      visit: "",
      description:
        "Restaurant and experience discovery application that focused on delivery high quality rich content through transcoded video streams. Created architectural framework, iOS implementation, and video transcoding on AWS to facilitate efficient user uploads and streaming in-application"
    },
    {
      name: "Project Poker",
      pictures: [
        {
          img: require("./src/assets/portfolio/personal/project-poker/uml-diagram.png")
        },
      ],
      technologies: ["Swift", "iOS", "python", "bluetooth", "Parse"],
      category: "iOS App",
      date: "May 2017",
      github:
        "",
      visit: "",
      description:
        "Local multiplayer blackjack application utilizing bluetooth to connect multiple devices to a host. Built and demoed via an iPad as the poker table with individual iPhones entering as players that can drop in and out. A Parse backend maintains a secure play across devices and centralized authentication as well as bank management."
    },
  ],
};

export default info;
